import Lozenge from './Lozenge';

export default Lozenge;
